module.exports = __webpack_public_path__ + "img/forecast.85e2ddc5.svg";